import { useRecoDialog } from '@/core/composables/useRecoDialog.ts';
import FindParticipantDialog from '@/modules/recruitment/components/FindParticipantDialog.vue';

export const useFindParticipantDialog = () => {
  const dialog = useRecoDialog();

  const open = () => {
    dialog.open(FindParticipantDialog, {});
  };

  return {
    open,
  };
};
